<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: displayMode === DisplayMode.Form }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Types de documents"
                createIconText="Ajouter un type de document"
                importDatasourceName="documenttypes"
                (created)="onDocumentTypeCreated()"
                (exported)="onDocumentTypesExported()"
                (imported)="onDocumentTypesImported()"
                (helped)="onDocumentTypesHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-document-types-list
            #itemsList
            (itemSelected)="onDocumentTypeSelected($event)"
            (itemDisplayed)="onDocumentTypeDisplayed($event)"
            (itemEdited)="onDocumentTypeEdited($event)"
            (itemDeleted)="onDocumentTypeDeleted($event)"
            (itemDuplicated)="onDocumentTypeDuplicated($event)"></app-document-types-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onDocumentTypeDisplayed(context?.formContext.item)"
                    (edited)="onDocumentTypeEdited(context?.formContext.item)"
                    (helped)="onDocumentTypesHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-document-type-detail [context]="context" (documentTypeUpdated)="onDocumentTypeUpdated($event)" (canceled)="onBackToList()"></app-document-type-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
